var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "profile_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "profile_svg__Header_-_Opt_1_Grey_",
    "data-name": "Header - Opt 1 (Grey)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M20 1c10.48 0 19 8.52 19 19s-8.52 19-19 19S1 30.48 1 20 9.52 1 20 1m0-1C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0z",
    fill: "#e1087e"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "profile_svg__cls-1",
    d: "M20 7.75c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM20 19.5c1.42 0 8.32.54 8.73 11H11.27c.41-10.46 7.31-11 8.73-11m0-1c-3.18 0-9.75 2-9.75 13h19.5c0-11-6.57-13-9.75-13z"
  }))));
}
export default SvgProfile;